import { FooterToolbarRow } from "@circle-react/components/QuickPostV3/Composer/FooterToolbarRow";
import { PostFields } from "@circle-react/components/QuickPostV3/Composer/PostFields";
import { ScheduledIndicator } from "@circle-react/components/QuickPostV3/Composer/ScheduledIndicator";
import { FloatingActions } from "@circle-react/components/QuickPostV3/Content/FloatingActions";
import { TopSpaceSelect } from "@circle-react/components/QuickPostV3/Content/TopSpaceSelect";
import { useComposerLayout } from "@circle-react/components/QuickPostV3/hooks/useComposerLayout";
import { QuickPostModalBody } from "@circle-react/components/QuickPostV3/QuickPostModalBody";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface BodyProps {
  hasFloatingChrome: boolean;
  shouldShowTipTap: boolean;
}

export const Body = ({ hasFloatingChrome, shouldShowTipTap }: BodyProps) => {
  const { shouldInlineTopics } = useComposerLayout();

  return (
    <div className="bg-secondary flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
      <div className="bg-primary relative flex min-h-0 flex-1 flex-col overflow-hidden rounded-b-lg">
        {hasFloatingChrome && <FloatingActions />}
        <QuickPostModalBody
          customLayout
          hasFloatingChrome={hasFloatingChrome}
          data-testid="quick-post-v3-body"
        >
          <div
            className={classNames(
              "flex min-h-full flex-col",
              hasFloatingChrome && "py-20",
            )}
          >
            {hasFloatingChrome && (
              <>
                <TopSpaceSelect />
                <ScheduledIndicator />
              </>
            )}
            <PostFields shouldShowTipTap={shouldShowTipTap} />
          </div>
        </QuickPostModalBody>
        <FooterToolbarRow
          inline={shouldInlineTopics}
          floating={hasFloatingChrome}
        />
      </div>
    </div>
  );
};
